import { BaseSVG } from 'shared/BaseSVG';
import { translate } from 'App/Internationalization';
import { withApplianceService } from 'service-container';
import BaseField from 'shared/Forms/Fields/BaseField';
import BaseForm from 'shared/Forms/BaseForm';
import images from 'config/local/images';
import LinkButton from 'shared/LinkButton';
import Loading from '../../../shared/Loading';
import paths from 'config/local/paths';
import React from 'react';
import SubmitButton from 'shared/Forms/Inputs/SubmitButton';

export class ViewManuals extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			applianceList: [],
			initialValues: {
				appliance: this.props.location?.state?.manual ?? '',
			},
			isGettingData: true,
			previousSearchTerm: '',
		};

		this.baseForm = React.createRef();
		this.handleSubmit = this.handleSubmit.bind(this);
		this.searchManuals = this.searchManuals.bind(this);
	}

	async handleSubmit(values) {
		await this.searchManuals(values.appliance);
		return {
			previousSearchTerm: values.appliance,
		};
	}

	async searchManuals(searchTerm) {
		if (searchTerm !== this.state.previousSearchTerm) {
			this.setState({
				isGettingData: true,
			});
		}

		try {
			const result = await this.props.applianceService.getManuals(
				searchTerm
			);

			this.setState({
				applianceList: result,
				isGettingData: false,
			});
		} catch (error) {
			this.setState({
				applianceList: [],
				isGettingData: false,
			});
		}
	}

	async componentDidMount() {
		this.setState({
			previousSearchTerm: this.props.location.state.manual,
		});

		await this.searchManuals(this.props.location.state.manual);
	}

	render() {
		const propertyId = this.props.match?.params?.propertyId;
		const applianceRootPath = propertyId
			? paths.app.homeowner.properties.scoped.appliances.replace(
					':propertyId',
					propertyId
			  )
			: paths.app.homeowner.applianceCenter.root;

		const applianceList = this.state.applianceList.map((appliance) => (
			<li
				key={`${appliance.brand}-${appliance.model}-${appliance.manual}`}
			>
				<a
					className="no-underline text-default-color"
					href={appliance?.manual}
					rel="noreferrer noopener"
					target="_blank"
				>
					<header className="order-2">
						<h4>
							{appliance.brand} {appliance.model}
						</h4>
						<p>{appliance.category}</p>
						<p>
							{translate(
								'homeowner.pages.appliance_center.manual.view'
							)}
						</p>
					</header>
					<BaseSVG
						className="h-16 mr-2 order-1 w-16"
						path={images.icons.file}
					/>
				</a>
			</li>
		));

		return (
			<section className="flex flex-col flex-1">
				<header className="mb-4 flex flex-row items-center justify-between">
					<h3 className="mr-4 text-xl">
						{translate(
							'homeowner.pages.appliance_center.manuals.title'
						)}
					</h3>
					<LinkButton
						hoverColor="primary-active"
						to={applianceRootPath}
					>
						{translate(
							'homeowner.pages.appliance_center.manuals.return'
						)}
					</LinkButton>
				</header>
				<section className="appliance-form">
					<BaseForm
						className="layout flex-1"
						initialValues={this.state.initialValues}
						innerRef={this.baseForm}
						noRequiredText="false"
						onSubmit={this.handleSubmit}
						ref={this.baseForm}
					>
						<BaseField
							className="flex-1"
							labelClass="sr-only"
							name="appliance"
							placeholder={translate(
								'homeowner.pages.appliance_center.search.placeholder'
							)}
							type="search"
						/>
						<SubmitButton hoverColor="primary-active" type="submit">
							{translate(
								'homeowner.pages.appliance_center.search.button'
							)}
						</SubmitButton>
					</BaseForm>
				</section>
				<ul className="appliance-list">
					{this.state.isGettingData ? (
						<li>
							<Loading />
						</li>
					) : (
						applianceList
					)}
				</ul>
			</section>
		);
	}
}

export default withApplianceService(ViewManuals);
